import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AdornmentsService } from '../adornments.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[focusArea]',
  standalone: false
})
export class FocusAreaDirective implements OnInit, OnDestroy {

  @Input() focusLabel: string;

  @Output() jumpFocus = new EventEmitter<void>();

  constructor(
    private adornmentsService: AdornmentsService,
    private el: ElementRef<any>
  ) { }

  private onFocusCallback() {
    this.jumpFocus.emit();
  }

  ngOnInit(): void {
    this.adornmentsService.registerFocusArea(this.el.nativeElement, this.focusLabel, this.onFocusCallback.bind(this));
  }

  ngOnDestroy(): void {
    this.adornmentsService.unregisterFocusArea(this.el.nativeElement);
  }
}
